import $ from "jquery"
import Vue from "vue"
import * as ers from "../../../errorsmessages/errors"
import * as suc from "../../../successmessages/success"
import * as rt from "../../../routes/routes"
import * as ses from "../../../configurations/session/sessioncomplete"
import authservice from "../../../configurations/authentications/auth"
import baseurl from "../../../configurations/baseurl/baseurl"
import router from "../../../router/index"


let Auth = new authservice()


export const actions = {

    newRole() {

        let roles = {
            rolename: $('.rolename').val(),
            slug: $('.roleSlug').val()
        }
        $('.creatingRoleLoader').show()
        $('.creatingRole').hide()
        baseurl
            .post(rt.addNewRole, roles)
            .then(res => {
                $('.creatingRoleLoader').hide()
                $('.creatingRole').show()
                $('.form-control').val("")
                if (res.data.code === 200) {
                    suc.roleCreateSuccess()
                } else if (res.data.code === 402) {
                    ers.validateErrors()
                } else if (res.data.code === 403) {
                    ers.roleExists()
                } else if (res.data.code === 404) {
                    ers.errorCreatingRole()
                }else if(res.data.code === 405){
                    ers.noPermissionToCreate()
                    router.push("/dashboard");
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }
            })
    },

    loadRoles({ commit }) {
        baseurl
            .get(rt.LoadRoles)
            .then(res => {
                $('.rolesLoader').hide()
                $('.userrolesLoader').hide()
                if (res.data.code === 200) {
                    commit('STORE_SYSTEM_ROLES', res.data.roles)
                } else if (res.data.code === 404) {
                    ers.errorLoadingRoles()
                }else if(res.data.code === 405){
                    ers.noPermissionToRead()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },

    viewRole({ commit }, data) {
        commit('STORE_ROLE_UPDATE', data)
        router.push('/updateRole')
    },

    RoleUpdate({ commit }) {
        let roles = {
            id: $('.roleId').val(),
            rolename: $('.rolename').val(),
            slug: $('.roleSlug').val()
        }
        $('.updateRoleLoader').show()
        $('.updateRole').hide()
        baseurl
            .post(rt.updateRole, roles)
            .then(res => {
                $('.updateRoleLoader').hide()
                $('.updateRole').show()
                if (res.data.code === 200) {
                    suc.roleUpdateSuccess()
                    commit('STORE_SYSTEM_ROLES', res.data.roles)
                    setTimeout(() => {
                        router.push('/managerole')
                    }, 3000);
                } else if (res.data.code === 402) {
                    ers.validateErrors()
                } else if (res.data.code === 404) {
                    ers.errorUpdatingRole()
                }else if(res.data.code === 405){
                    ers.noPermissionToUpdate()
                    router.push("/dashboard");
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },

    deleteRole({ commit }, roleId) {

        Vue.swal.fire({ title: 'Are you sure?', text: 'You want to delete this role..?!', type: "warning", showCancelButton: true }).then(result => {
            if (result.value) {
                window.$("#rolesLoaderModal").modal("show");
                baseurl
                    .get(rt.deleteRole + roleId)
                    .then(res => {
                        window.$("#rolesLoaderModal").modal("hide");
                        if (res.data.code === 200) {
                            suc.roleDeleteSuccess()
                            setTimeout(() => {
                                $('.rolesLoader').show()
                                setTimeout(() => {
                                    commit('STORE_SYSTEM_ROLES', res.data.roles)
                                    $('.rolesLoader').hide()
                                }, 200);

                            }, 3000);

                        } else if (res.data.code === 404) {
                            ers.errorDeletingRole()
                        }else if(res.data.code === 405){
                            ers.noPermissionToDelete()
                        } else if (res.data.code === 506) {
                            ses.sessionComplete()
                        }

                    })
            }
        })

    }

}

export default actions


// WEBPACK FOOTER //
// ./src/vuex/modules/roles/actions.js